package com.milta.core.localization.translations.es

import com.milta.core.localization.ErrorStrings

internal val Errors = ErrorStrings(
    generic = "Se produjo un error",
    error = "Error",
    fieldRequired = "Este campo es obligatorio",
    invalidEmail = "Dirección de email inválida",
    fileTooLarge = "Archivo demasiado grande. Elige un archivo más ligero.",
)
